import { memo } from "react"
import {
  IconButton,
  ListItemButton as MuiListItemButton,
  ListItemText,
  styled,
  Stack,
  ListItem,
  type ListItemProps,
} from "@mui/material"
import { LockRounded, MoreVert } from "@mui/icons-material"
import { CollectionListItemCover } from "./CollectionListItemCover"
import { useCollectionActionsDrawer } from "../CollectionActionsDrawer/useCollectionActionsDrawer"
import { getCollectionComputedMetadata } from "../getCollectionComputedMetadata"
import { useCollection } from "../useCollection"
import { useCollectionDisplayTitle } from "../useCollectionDisplayTitle"
import { useConfig } from "../../config/useConfig"
import { generatePath, useNavigate } from "react-router"
import { ROUTES } from "../../navigation/routes"

const ListItemButton = styled(MuiListItemButton)(({ theme }) => ({
  padding: theme.spacing(2),
}))

export const CollectionListItem = memo(function CollectionListItem({
  id,
  showType,
  ...rest
}: {
  id: string
  showType?: boolean
} & ListItemProps) {
  const { data: config } = useConfig()
  const { data: item } = useCollection({
    id,
  })
  const navigate = useNavigate()
  const metadata = getCollectionComputedMetadata(item)
  const { open: openActionDrawer } = useCollectionActionsDrawer(id)
  const title = useCollectionDisplayTitle(metadata.title)

  return (
    <ListItem
      onClick={() => {
        if (item) {
          navigate(generatePath(ROUTES.COLLECTION_DETAILS, { id: item._id }))
        }
      }}
      component="div"
      disablePadding
      dense
      {...rest}
    >
      <ListItemButton
        disableGutters
        sx={{
          display: "flex",
          flexDirection: "column",
          alignSelf: "stretch",
        }}
      >
        <CollectionListItemCover id={id} showType={showType} />
        <Stack
          direction="row"
          onClick={(e) => {
            if (id !== config?.COLLECTION_EMPTY_ID) {
              e.stopPropagation()
              openActionDrawer()
            }
          }}
          sx={{
            width: "100%",
            alignItems: "center",
          }}
        >
          <ListItemText
            primary={title ?? `\u00a0`}
            secondary={`${item?.books?.length || 0} book(s)`}
            slotProps={{
              primary: {
                sx: {
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                },
              },
            }}
          />

          {id !== config?.COLLECTION_EMPTY_ID && (
            <IconButton
              disableFocusRipple
              disableRipple
              disableTouchRipple
              size="large"
            >
              <MoreVert />
            </IconButton>
          )}
          {id === config?.COLLECTION_EMPTY_ID && (
            <IconButton
              disableFocusRipple
              disableRipple
              disableTouchRipple
              size="large"
            >
              <LockRounded />
            </IconButton>
          )}
        </Stack>
      </ListItemButton>
    </ListItem>
  )
})
